import { render, staticRenderFns } from "./entrance.vue?vue&type=template&id=03bae46d&scoped=true&"
import script from "./entrance.vue?vue&type=script&lang=js&"
export * from "./entrance.vue?vue&type=script&lang=js&"
import style0 from "./entrance.vue?vue&type=style&index=0&id=03bae46d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bae46d",
  null
  
)

export default component.exports